import React from 'react';
import { EmbedWidgetManagement } from '../../../pages/EmbedWidgetManagement';
import { FeatureReadOnlyBanner } from '../components/FeatureReadOnlyBanner';

export const EmbedWidgetsRoute: React.FC = () => (
  <>
    <FeatureReadOnlyBanner feature="embed_widget" />
    <EmbedWidgetManagement />
  </>
);
